import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Avatar, Text, Truncated } from '@frontend/design-system';
import { ColumnHeaderWrapper } from '../column-header-wrapper';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  avatarProps: React.ComponentProps<typeof Avatar>;
  labelText: string;
  counter?: number;
  onClick?: () => void;
}

export const AvatarPill = ({ labelText, avatarProps, counter = 0, onClick, ...rest }: Props) => {
  return (
    <ColumnHeaderWrapper
      containerStyle={[containerStyle, onClick && { cursor: 'pointer' }]}
      {...rest}
      onClick={onClick}
    >
      <div css={avatarWrapperStyle}>
        <Avatar size='small' css={avatarStyle} {...avatarProps} />
        {counter > 0 && (
          <Text as='span' weight='bold' css={counterStyle}>
            {counter}
          </Text>
        )}
      </div>
      <Truncated as={Text} weight='bold' size='small' css={labelStyle} tooltipOptions={{ hoverDelay: 300 }}>
        {labelText}
      </Truncated>
    </ColumnHeaderWrapper>
  );
};

const containerStyle = css({
  padding: theme.spacing(0.25, 1),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  containerType: 'inline-size',
  '@container (width < 90px)': {
    p: {
      display: 'none',
    },
  },
});

const avatarWrapperStyle = css({
  position: 'relative',
});

const avatarStyle = css({
  fontSize: theme.font.size.medium,
});

const counterStyle = css({
  fontSize: theme.font.size.xs,
  borderRadius: theme.borderRadius.medium,
  background: theme.colors.neutral90,
  color: theme.colors.white,
  boxShadow: `${theme.shadows.innerRight}, ${theme.shadows.light}`,
  position: 'absolute',
  left: theme.spacing(-1),
  top: 0,
  minWidth: 16,
  minHeight: 16,
  textAlign: 'center',
  padding: theme.spacing(0, 0.5),
});

const labelStyle = css({
  maxWidth: 'max-content',
  marginLeft: theme.spacing(-1.5),
  padding: theme.spacing(0.5, 0.5, 0.5, 2.5),
  borderRadius: theme.borderRadius.small,
  userSelect: 'none',
});
